module.exports = __webpack_public_path__ + "static/ja-1b00632610d9f4c195cae400e365dbfa.png";